
import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Form } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import cryptoJs from 'crypto-js';
import Toastr from '../utils/toastr';
import TwoFA from './twoFA';
import { setSupervisorData, updateLayout } from '../../redux/supervisorSlice';
import { setConfig } from '../../redux/parametersSlice';
import useMonitorAPIService from '../../services/monitorapiservice';
import RecoverPassword from './recoverPassword';

function Login(props) {

    const { t } = useTranslation();
    const { login, resend, checkhashedpass, checkRecover } = useMonitorAPIService();
    const [hashedPassword, setHashedPassword] = useState(false);
    const [tenantName] = useState(window.location.host.split(".")[0]);
    const [tenantAlias] = useState(window.location.hostname);
    const [userName, setUserName] = useState("");
    const [userNameIsEmpty, setUserNameIsEmpty] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordIsEmpty, setPasswordIsEmpty] = useState(false);
    const [logged, setLogged] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showCodeReq, setShowCodeReq] = useState(false);
    const toastrRef = useRef(null);
    const [userLocalStorage] = useState(false);
    const [recover, setRecover] = useState(false);
    const [showRecover, setShowRecover] = useState(false);

    const handleSubmit = (token) => {

        let invalidUsr = userName === null || (userName !== null && userName.trim() === ""),
            invalidPwd = password === null || (password !== null && password.trim() === "");

        setUserNameIsEmpty(invalidUsr);
        setPasswordIsEmpty(invalidPwd);

        if (!invalidUsr && !invalidPwd) {

            let hostName = window.location.hostname;
            let tenant = tenantName;
            let alias = tenantAlias;
            setLoading(true);
            //! TODO: Trampa
            if (hostName === 'localhost' || hostName === '127.0.0.1') {
                tenant = "devomni";
                alias = "devomni";
            }


            let userdata = {
                "username": userName,
                "password": userLocalStorage || !hashedPassword ? password : cryptoJs.SHA512(password).toString(),
                "tenant": tenant,
                "tenantAlias": alias,
                "loginToken": token,
                "userLocalStorage": userLocalStorage
            };

            login(userdata, res => {
                if (res.data !== null && res.data !== "" && res.data.supervisor && res.data.id !== null) {

                    if (res.data.layout !== null && res.data.layout.trim() !== "") {
                        let data = JSON.parse(res.data.layout);
                        let keys = Object.keys(data).filter(x => x.endsWith(`user${res.data.id}`));
                        keys.forEach(v => {
                            localStorage.setItem(v, data[v]);
                            if (v.startsWith("layout")) {
                                props.updateLayout(JSON.parse(data[v]));
                            }
                        });
                    }

                    props.setSupervisorData(res.data);

                    localStorage.setItem("faChangePwd", res.data.changePassword)
                    setLoading(false);

                    setLogged(true);
                } else {

                    if (res.data.message === "CODE_REQUIRED") {
                        setShowCodeReq(true);
                    }

                    if (res.data.message === "USER_LOCKED") {
                    }

                    if (res.data.message === "ERROR" || res.data === "" || !res.data.supervisor) {
                        toastrRef.current.setMessage(t("wronguserorpasswordorextension"));
                        toastrRef.current.show();
                    }
                    setLoading(false);
                }


            });
        }
    };

    const toggleTwoFactorAuth = () => {
        setShowCodeReq(!showCodeReq);
        if (!showCodeReq)
            handleSubmit();
    };

    const resendCode = (callBack) => {

        let userdata = {
            "username": userName,
            "password": userLocalStorage || !hashedPassword ? password : cryptoJs.SHA512(password).toString(),
            "tenant": tenantName,
            "tenantAlias": tenantAlias
        };

        resend(userdata, res => {
            if (res.data === "OK") {
                toastrRef.current.setType("success");
                toastrRef.current.setMessage(t("tokensent"));
                toastrRef.current.show();
            } else {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            }
            callBack();
        });
    };

    const toggleRecoverPwd = () => {
        setShowRecover(!showRecover);
    };


    useEffect(() => {
        checkhashedpass(res => {
            setHashedPassword(res.data);
            setLoading(false);
        });
    }, [checkhashedpass]);

    useEffect(() => {
        let data = {
            "tenant": window.location.host.split(".")[0],
            "tenantAlias": window.location.hostname
        };
        checkRecover(data, res => {
            setRecover(res.data);
            setLoading(false);
        });
    }, [checkRecover]);

    if (logged) {
        return <Navigate to="/main/dashboard" />
    }

    return (<>
        <BlockUi tag="div" blocking={loading} color="#009ef7" message={t("pleasewait")} style={{ height: "100%" }}>
            <div className="app-blank" style={{ height: "100%" }}>
                <div className="d-flex flex-column flex-root" style={{ height: "100%" }}>
                    <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                        <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
                            <div className="d-flex flex-center flex-column flex-lg-row-fluid">
                                <div className="w-lg-500px p-10">
                                    <Form>
                                        <div className="text-center mb-11">
                                            <h1 className="text-primary mb-3">{t("welcometitle")}</h1>
                                            <div className="text-gray-500 fs-6">{t("omnichannel")}</div>
                                        </div>
                                        <div className="fv-row mb-8" data-kt-password-meter="true">

                                            <Form.Group className="mb-4" controlId="fcUserName">
                                                <Form.Control type="text" value={userName} onChange={e => setUserName(e.target.value)} placeholder={t("username")} isInvalid={userNameIsEmpty} />
                                                {
                                                    (userNameIsEmpty) &&
                                                    <Form.Text id="passwordHelpBlock" className='text-danger'>
                                                        {t("usernammeisempty")}
                                                    </Form.Text>
                                                }
                                            </Form.Group>

                                            <Form.Group className="mb-4" controlId="fcPassword">
                                                <Form.Control type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder={t("password")} isInvalid={passwordIsEmpty} />
                                                {
                                                    (passwordIsEmpty) &&
                                                    <Form.Text id="passwordHelpBlock" className='text-danger'>
                                                        {t("passwordisempty")}
                                                    </Form.Text>
                                                }
                                            </Form.Group>
                                        </div>
                                        <div className="d-grid mb-10">
                                            <Button variant="primary" onClick={e => { handleSubmit(""); }} className="btn btn-primary">
                                                {t("bind")}
                                            </Button>
                                        </div>
                                        {
                                            recover &&
                                            <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                                                <a href="/#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        toggleRecoverPwd();
                                                    }}
                                                    className="link-primary">
                                                    {t("recoverpwd")}
                                                </a>
                                            </div>
                                        }
                                    </Form>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2" style={{ backgroundImage: "url(img/background.jpg)" }}>
                            <div className="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100">
                                <div className="mb-0">
                                    <img alt="Logo" src="img/loginlogo.png" className="h-10px h-lg-150px" />
                                </div>
                                <img className="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20" src="img/login.png" alt="" />
                                <h1 className="d-none d-lg-block text-white text-center mb-7">{t("welcomeheader")}</h1>
                                <div className="d-none d-lg-block text-white fs-base text-center">
                                    {t("welcomedescfirst")}
                                    <br />
                                    {t("welcomedescsecond")}
                                    <br />
                                    {t("welcomedescthird")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </BlockUi>

        <Toastr ref={toastrRef} />
        <TwoFA show={showCodeReq} toggleModal={toggleTwoFactorAuth} resend={resendCode} submit={handleSubmit}></TwoFA>
        <RecoverPassword show={showRecover} toggleModal={toggleRecoverPwd}></RecoverPassword>

    </>

    )
}



const mapStateToProps = (state) => {
    return {
        server: state.supervisor.server,
    };
};
export default connect(mapStateToProps, { setSupervisorData, setConfig, updateLayout })(Login);
